import areUniform from './lib/areUniform';
import chain from './lib/chain';
import classify from './lib/classify';
import classifyAsEntries from './lib/classifyAsEntries';


// Re-export each method in the library to allow consumers to import individual methods.
export {default as areUniform} from './lib/areUniform';
export {default as chain} from './lib/chain';
export {default as classify} from './lib/classify';
export {default as classifyAsEntries} from './lib/classifyAsEntries';


// Set the default export to contain all methods.
export default {
  areUniform,
  chain,
  classify,
  classifyAsEntries
};



// WEBPACK FOOTER //
// ./src/index.js